import React from "react";

interface VehicleHirePaymentMethodBadgeProps {
    vehicleHire: CustomerAPIVehicleHire
}

const VehicleHirePaymentMethodBadge = (
    {vehicleHire}: VehicleHirePaymentMethodBadgeProps
) => {

    return (
        <span className="badge bg-dark p-2">{vehicleHire.paymentMethod}</span>
    )

}

export default VehicleHirePaymentMethodBadge;
